($ => {
	var utils;
	function calcCellTable() {
		$('.table').map((_, table) => {
			const headCells = $('.table__head .table__cell', table);
			const rows = $('.table__body .table__item', table);
			const minWidths = [];
			// Construct our min widths
			headCells.map((_, cell) => {
				$(cell).width('auto');
				const width = $(cell).width();
				minWidths.push(width);
			});
			rows.map((_, row) => {
				const rowCells = $('.table__cell', row);
				rowCells.map((i, cell) => {
					$(cell).width('auto');
					const width = $(cell).width();
					const isLarger = minWidths[i] < width;
					minWidths[i] = isLarger ? width : minWidths[i];
				});
			});
			// use our minWidths
			headCells.map((i, cell) => {
				$(cell).width(minWidths[i]);
			});
			rows.map((_, row) => {
				const rowCells = $('.table__cell', row);
				rowCells.map((i, cell) => {
					$(cell).width(minWidths[i]);
				});
			});
		});
	}

	// Ça fonctionne pas, j'ai besoin d'Avoir aussi le param sortOrder/order dans le xslt
	// il faudrait aussi que j'aille chercher tous les data-sort-name de la table pour enlever les autres de l'url au click de un
	// Je crois qu'il faudrait permettre de passer le currentHref au addOrReplaceParam() aussi pour pouvoir modifier plusieurs fois le href
	function onTableHeadItemSortClick() {
		var cell = $(this);
		var table = cell.closest('.table');
		var requestParams = utils.getRequestParams();
		var sortName = cell.attr("data-sort-name");
		var sortParam = cell.attr("data-sort-param");
		var sortOrderParam = cell.attr("data-sort-order-param");
		var allSortNames = $.map($('.table__cell[data-sort-name]', table), thisCell => thisCell.dataset.sortName);
		var currentHref = location.href;
		var newRequestParams = requestParams;
		for (var i in allSortNames) { delete newRequestParams[allSortNames[i]]; }
		newRequestParams[sortParam] = sortName;

		var newOrder = "desc";
		// If already sorting by this param, toggle the order asc/desc
		if (requestParams.hasOwnProperty(sortParam)) {
			var order = requestParams[sortOrderParam];
			newOrder = order == "desc" ? "asc" : "desc";
		}
		newRequestParams[sortOrderParam] = newOrder;

		var stringParams = utils.requestParamsObjectToString(newRequestParams);
		location.href = currentHref.split('?')[0] + stringParams;
	}

	function init() {
		utils = Fw.component.models().utils;
		const haveTable = $('.table').length > 0;
		if(haveTable) {
			calcCellTable();
			$(window).resize(calcCellTable);
		}
		$('.table__opener').click(({currentTarget}) => {
			const item = $(currentTarget).closest('.table__item');
			item.toggleClass('table__item_active');
			$('.table__actions, .table__content', item).slideToggle('medium');
		});

		$('.table__cell[data-sort-name]').on('click', onTableHeadItemSortClick);
	}
	$(init);
})(jQuery);
